import { render } from "./LanguageSwitch.vue?vue&type=template&id=081afa23&ts=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__